import request from '../index';
/** 和生产计划有关的接口 **/

/** 
* ProductionInstruction
* @params {string} data.applications 用途
* @params {string} data.approveDate 批准日期
* @params {string} data.approver 批准人
* @params {string} data.batchNumber 生产批号
* @params {string} data.checked 核对人
* @params {string} data.checkedDate 核对时间
* @params {string} data.edition 版本
* @params {string} data.finishDate 完成时间
* @params {string} data.formNumber 表单编号
* @params {string} data.goodsIssue 发料人
* @params {string} data.goodsIssueDate 发料时间
* @params {number} data.id 
* @params {string} data.modelSpecifications 型号规格
* @params {number} data.number 数量
* @params {string} data.pickDate 领料时间
* @params {string} data.picker 领料人
* @params {array} data.pqcList 
* @params {string} data.produceDate 生产日期
* @params {string} data.produceOrTpc 生产模块or试产中心
* @params {string} data.productName 产品名称
* @params {array} data.productNumberList 
* @params {string} data.reviewDate 审核日期
* @params {string} data.reviewer 审核人
* @params {string} data.unit 单位
* @params {string} data.writeDate 编制日期
* @params {string} data.writer 编制人
*/

/** 
* 天鹅产线半成品库存信息
* @params {string} params.modelSpecifications 项目型号规格
* @params {string} params.produceOrTpc 生产模块or试产中心
* @params {string} params.status 合格/不合格
* @params {string} params.type 工序
*/
export const getInventoryInfo = (params) => request.get('/api-qc/getInventoryInfo', { params });

/** 
* 获得生产指令单列表
* @params {string} params.endDate 结束时间
* @params {string} params.produceDate 生产日期
* @params {string} params.produceOrTpc 生产模块or试产中心
* @params {string} params.productName 产品名称
* @params {string} params.startDate 开始时间
*/
export const getProductionInstructionList = (params) => request.get('/api-qc/getProductionInstructionList', { params });

/** 
* 添加生产指令单
* @params {ProductionInstruction} productionInstruction
*/
export const insertProductionInstruction = (data) => request.post('/api-qc/insertProductionInstruction', data);

/** 
* 合格率数据汇总
* @params {string} params.modelSpecifications 项目型号规格
* @params {string} params.produceOrTpc 生产模块or试产中心
* @params {string} params.year 年度
*/
export const summaryOfQualifiedRateData = (params) => request.get('/api-qc/summaryOfQualifiedRateData', { params });

/** 
* 不合格率汇总环比数据
* @params {string} params.modelSpecifications 项目型号规格
* @params {string} params.produceOrTpc 生产模块or试产中心
* @params {string} params.year 年
*/
export const summaryOfUnqualifiedRateQOQData = (params) => request.get('/api-qc/summaryOfUnqualifiedRateQOQData', { params });

/** 
* 不合格率数据汇总
* @params {string} params.modelSpecifications 项目型号规格
* @params {string} params.produceOrTpc 生产模块or试产中心
* @params {string} params.year 年度
*/
export const summaryOfUnqualifiedRateData = (params) => request.get('/api-qc/summaryOfUnqualifiedRateData', { params });

/** 
* 不合格问题明细
* @params {string} params.modelSpecifications 项目型号规格
* @params {string} params.produceOrTpc 生产模块or试产中心
* @params {string} params.yearMonth 年月
*/
export const unqualifiedProblemDetails = (params) => request.get('/api-qc/unqualifiedProblemDetails', { params });

/** 
* 更新生产指令单
* @params {ProductionInstruction} productionInstruction
*/
export const updateProductionInstruction = (data) => request.put('/api-qc/updateProductionInstruction', data);

/** 
* 更新领料单
* @params {MaterialRequisition} materialRequisition
*/
export const updateMaterialRequisition = (data) => request.put('/api-qc/updateMaterialRequisition', data);

/** 
* 更新领料单详情
* @params {array} list
*/
export const updateMaterialRequisitionDetailList = (data) => request.put('/api-qc/updateMaterialRequisitionDetailList', data);

/** 
* 添加领料单
* @params {MaterialRequisition} materialRequisition
*/
export const insertMaterialRequisition = (data) => request.post('/api-qc/insertMaterialRequisition', data);

/** 
* 获得领料单列表
* @params {string} params.batchNumber 生产批号
* @params {string} params.outputNumber 输出编号
* @params {string} params.produceDate 生产日期
* @params {string} params.produceOrTpc 生产模块or试产中心
* @params {string} params.type 工序
*/
export const getMaterialRequisitionList = (params) => request.get('/api-qc/getMaterialRequisitionList', { params });
